import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import web5 from "../img/mapp.jpg";
import "../style/styles.css";
import "../style/Website.css";

const Website = () => {
  const alText = "Website and mobile app development services";

  const expertiseItems = [
    {
      title: "Custom Web Development",
      text:
        "Take advantage of our custom web development services to start your digital journey. We are skilled at transforming your idea into a smooth and interesting online presence, whether it be for sophisticated corporate websites or intricate web applications.",
    },
    {
      title: "Responsive Web Design",
      text:
        "It is imperative to have a responsive website in the age of smartphone dominance. Our design team makes sure your website looks amazing and works perfectly on all devices, giving your audience the best possible user experience.",
    },
    {
      title: "E-Commerce Solutions",
      text:
        "Open your digital storefront with confidence. Our e-commerce development services are designed to enhance your online retail presence, providing secure, scalable, and feature-rich solutions to drive sales and customer satisfaction.",
    },
    {
      title: "Content Management Systems (CMS)",
      text:
        "Utilize our CMS solutions to regain control over your content. Using WordPress, Drupal, or a custom-built system, we give you the ability to easily update and manage your website, keeping it current and engaging.",
    },
  ];

  const webReasons = [
    {
      title: "Innovative Solutions",
      text:
        "Stay ahead of the curve with our forward-thinking approach to web development.",
    },
    {
      title: "Collaborative Process",
      text:
        "We believe in collaboration, working closely with you to understand your goals and vision.",
    },
    {
      title: "Quality Assurance",
      text:
        "Every line of code undergoes rigorous testing to ensure a flawless, secure, and reliable website.",
    },
    {
      title: "Dedicated Support",
      text:
        "Your success is our priority. Our support team is here to assist you post-launch and beyond.",
    },
  ];

  const appItems = [
    {
      title: "Custom Mobile App Development",
      text:
        "Our team of talented developers is experienced in producing unique solutions, regardless of whether you're thinking of developing an app for iOS, Android, or both platforms. We create apps that not only meet but also surpass your expectations by combining usability, aesthetics, and user experience.",
    },
    {
      title: "Cross-Platform Development",
      text:
        "Increase your audience reach by using cross-platform development. Because of our proficiency with frameworks like React Native and Flutter, we can create apps that function flawlessly across a variety of platforms, cutting costs and development time without sacrificing quality.",
    },
    {
      title: "UI/UX Design",
      text:
        "An excellent app is about more than just its features; it's about the user interface. Our design team creates visually appealing and user-friendly interfaces that increase app store visibility and boost user engagement.",
    },
    {
      title: "Upkeep and Assistance for Apps",
      text:
        "Your app's launch is only the first step. To make sure your app remains safe, current, and performs at its best, we provide continuing maintenance and support services.",
    },
  ];

  const appReasons = [
    {
      title: "Innovation at the Core",
      text:
        "We provide cutting-edge solutions that keep you ahead of the curve by staying up to date with the newest trends and technologies.",
    },
    {
      title: "Collaborative Approach",
      text:
        "We prioritize your vision. We work closely with you every step of the way to make sure the finished product perfectly meets your needs.",
    },
    {
      title: "Quality Assurance",
      text:
        "To ensure a bug-free, dependable, and secure application, each line of code is put through extensive testing.",
    },
    {
      title: "Client-Centric Support",
      text:
        "Our committed support staff is available to help you at every stage of your app's lifecycle, from conception to launch and beyond.",
    },
  ];

  const highlights = [
    "Custom Web Development",
    "Responsive Web Design",
    "E-Commerce Solutions",
    "CMS Development",
    "Android App Development",
    "iOS App Development",
  ];

  const seoKeywords = [
    "Website Development Company",
    "Website Development Services",
    "Custom Website Development",
    "Business Website Development",
    "Corporate Website Development",
    "Responsive Website Design",
    "Professional Website Design",
    "Web Application Development",
    "Custom Web Application Development",
    "E-Commerce Website Development",
    "Online Store Development",
    "CMS Website Development",
    "WordPress Website Development",
    "React Website Development",
    "PHP Website Development",
    "Landing Page Design",
    "UI UX Design Services",
    "Website Redesign Services",
    "Website Maintenance Services",
    "SEO Friendly Website Development",
    "Android App Development",
    "iOS App Development",
    "Mobile App Development",
    "Custom Mobile App Development",
    "Cross Platform App Development",
    "Flutter App Development",
    "React Native App Development",
    "Business App Development",
    "E-Commerce App Development",
    "Android App Development Company",
    "Mobile App Development Company",
    "Website Development in India",
    "Website Development in Siliguri",
    "Website Development in West Bengal",
    "Android App Development in India",
    "Android App Development in Siliguri",
    "Mobile App Development in West Bengal",
  ];

  const relatedSearchGroups = [
    {
      title: "Website Development Services",
      text:
        "EBS Software Solution provides professional website development services for business websites, corporate websites, landing pages, custom web applications and SEO-friendly online presence.",
      terms: [
        "Website Development Company",
        "Website Development Services",
        "Custom Website Development",
        "Business Website Development",
        "Corporate Website Development",
        "Professional Website Design",
        "Responsive Website Design",
        "SEO Friendly Website Development",
        "Landing Page Design",
        "Website Redesign Services",
        "Website Maintenance Services",
        "Web Development Company",
      ],
    },
    {
      title: "Web Application & Custom Software Development",
      text:
        "We develop custom web applications and business automation systems with secure workflow, database integration, reporting, user access control and scalable architecture.",
      terms: [
        "Web Application Development",
        "Custom Web Application Development",
        "Business Web Application",
        "Custom Software Development",
        "Business Automation Software",
        "Database Driven Web Application",
        "Admin Panel Development",
        "Dashboard Development",
        "ERP Web Application Development",
        "CRM Web Application Development",
        "PHP Web Development",
        "React Website Development",
      ],
    },
    {
      title: "E-Commerce & CMS Website Development",
      text:
        "EBS Software Solution builds e-commerce websites, online stores and CMS websites for businesses that need product listing, enquiry forms, content management and online selling features.",
      terms: [
        "E-Commerce Website Development",
        "Online Store Development",
        "Shopping Website Development",
        "E-Commerce Web Design",
        "Product Catalogue Website",
        "Business Catalogue Website",
        "CMS Website Development",
        "WordPress Website Development",
        "Custom CMS Development",
        "Content Management System Development",
        "E-Commerce App Development",
        "Online Business Website",
      ],
    },
    {
      title: "Android, iOS & Mobile App Development",
      text:
        "We create Android apps, iOS apps and cross-platform mobile applications for businesses that need mobile ordering, field operations, customer engagement and digital workflow.",
      terms: [
        "Android App Development",
        "iOS App Development",
        "Mobile App Development",
        "Custom Mobile App Development",
        "Android App Development Company",
        "Mobile App Development Company",
        "Business App Development",
        "Enterprise Mobile App Development",
        "Cross Platform App Development",
        "Flutter App Development",
        "React Native App Development",
        "Mobile Application Development Services",
      ],
    },
    {
      title: "UI/UX, App Design & Digital Experience",
      text:
        "Our design approach focuses on user-friendly layouts, responsive screens, modern interface design, mobile-first experience and smooth customer interaction.",
      terms: [
        "UI UX Design Services",
        "Website UI Design",
        "Mobile App UI Design",
        "Responsive UI Design",
        "User Interface Design",
        "User Experience Design",
        "App Interface Design",
        "Corporate Website Design",
        "Modern Website Design",
        "Professional Web Design",
        "Mobile Friendly Website Design",
        "User Friendly App Design",
      ],
    },
    {
      title: "Website & App Development by Location",
      text:
        "EBS Software Solution provides website development, web application development, Android app development and mobile app development services for businesses in Siliguri, West Bengal and India.",
      terms: [
        "Website Development in India",
        "Website Development in Siliguri",
        "Website Development in West Bengal",
        "Web Development Company in Siliguri",
        "Web Development Company in West Bengal",
        "Software Company in Siliguri",
        "Custom Software Development in Siliguri",
        "Android App Development in India",
        "Android App Development in Siliguri",
        "Mobile App Development in West Bengal",
        "App Development Company in Siliguri",
        "Website Design Company in Siliguri",
      ],
    },
  ];

  const siteUrl = (process.env.REACT_APP_SITE_URL || "https://ebssoftware.co.in").replace(/\/$/, "");
  const pagePath =
    typeof window !== "undefined" && window.location && window.location.pathname
      ? window.location.pathname
      : "/website";
  const pageUrl = `${siteUrl}${pagePath}`;
  const heroImageUrl = String(web5 || "").startsWith("http") ? web5 : `${siteUrl}${web5}`;

  const seoTitle =
    "Website & Android App Development | Web, E-Commerce, CMS and Mobile Apps";

  const seoDescription =
    "EBS Software Solution provides website development, responsive web design, e-commerce development, CMS, custom web application, Android app, iOS app, Flutter app and mobile app development services.";

  const websiteServiceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Website and Mobile App Development",
    serviceType: "Website Development, Web Application Development and Mobile App Development",
    url: pageUrl,
    image: heroImageUrl,
    description: seoDescription,
    provider: {
      "@type": "Organization",
      name: "EBS Software Solution",
      url: siteUrl,
    },
    areaServed: [
      {
        "@type": "Country",
        name: "India",
      },
      {
        "@type": "State",
        name: "West Bengal",
      },
      {
        "@type": "City",
        name: "Siliguri",
      },
    ],
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Website and App Development Services",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Custom Website Development",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Responsive Web Design",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "E-Commerce Website Development",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "CMS Website Development",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Android App Development",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "iOS App Development",
          },
        },
      ],
    },
    keywords: seoKeywords.join(", "),
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: siteUrl,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Website and App Development",
        item: pageUrl,
      },
    ],
  };

  const handleImageError = (event) => {
    event.currentTarget.style.display = "none";
  };

  return (
    <main className="website-page">
      <Helmet>
        <meta charSet="utf-8" />

        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords.join(", ")} />

        <link rel="canonical" href={pageUrl} />

        <meta name="robots" content="index, follow, max-image-preview:large" />
        <meta name="author" content="EBS Software Solution" />
        <meta name="language" content="English" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={heroImageUrl} />
        <meta property="og:site_name" content="EBS Software Solution" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={heroImageUrl} />

        <script type="application/ld+json">
          {JSON.stringify([websiteServiceSchema, breadcrumbSchema])}
        </script>
      </Helmet>

      <section className="website-hero">
        <div className="website-hero-overlay"></div>

        <Container className="website-hero-container">
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <div className="website-hero-content">
                <div className="website-kicker">
                  Web, Android & iOS Development
                </div>
                <h1>Web Site and App, Android App and iOS App Development</h1>
                <p>
                  Transforming ideas into digital reality with creative,
                  user-focused and productive digital solutions for websites,
                  web applications, e-commerce platforms, Android apps and iOS
                  apps.
                </p>
              </div>
            </Col>

            <Col lg={5}>
              <div className="website-hero-card">
                <span>Digital Solutions</span>
                <strong>Websites, Apps & E-Commerce Platforms</strong>
                <p>
                  We build corporate websites, custom web applications,
                  responsive designs, CMS solutions, Android apps and iOS apps.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="website-highlight-section">
        <Container>
          <div className="website-highlight-wrap">
            {highlights.map((item) => (
              <span key={item}>{item}</span>
            ))}
          </div>
        </Container>
      </section>

      <section className="website-intro-section">
        <Container>
          <Row className="g-4 align-items-center">
            <Col lg={6}>
              <div className="website-section-label">Overview</div>
              <h2>Transforming Ideas into Digital Reality</h2>

              <p>
                At EBS Software Solution, we think that the internet has the
                ability to improve online experiences and change businesses. As a
                web development and app development firm, we create
                user-focused, responsive and productive digital solutions that
                are customized to match each individual client's needs.
              </p>
            </Col>

            <Col lg={6}>
              <div className="website-image-card">
                <img
                  src={web5}
                  alt={alText}
                  className="website-main-image"
                  onError={handleImageError}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="website-expertise-section">
        <Container>
          <div className="website-section-heading">
            <span>Our Expertise</span>
            <h2>Website development services for modern businesses</h2>
            <p>
              We provide custom web development, responsive web design,
              e-commerce solutions and content management systems for complete
              online presence.
            </p>
          </div>

          <Row className="g-4">
            {expertiseItems.map((item) => (
              <Col lg={6} key={item.title}>
                <div className="website-service-card">
                  <span>✓</span>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="website-why-section">
        <Container>
          <div className="website-dark-card">
            <Row className="g-4 align-items-center">
              <Col lg={4}>
                <div className="website-section-label">Why Choose Us ?</div>
                <h2>Reliable web development with quality and support</h2>
              </Col>

              <Col lg={8}>
                <div className="website-reason-grid">
                  {webReasons.map((item) => (
                    <div className="website-reason-item" key={item.title}>
                      <span>✓</span>
                      <div>
                        <h3>{item.title}</h3>
                        <p>{item.text}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>

      <section className="website-app-section">
        <Container>
          <div className="website-section-heading">
            <span>Apps Development</span>
            <h2>Android, iOS and cross-platform app development</h2>
            <p>
              Our mobile app development approach combines usability, aesthetics
              and user experience to build applications that support your
              digital footprint.
            </p>
          </div>

          <Row className="g-4">
            {appItems.map((item) => (
              <Col lg={6} key={item.title}>
                <div className="website-app-card">
                  <span>✓</span>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="website-app-why-section">
        <Container>
          <Row className="g-4 align-items-stretch">
            <Col lg={5}>
              <div className="website-app-why-left">
                <div className="website-section-label">
                  Why Choose us for App Development?
                </div>
                <h2>Innovation, collaboration, quality and support</h2>
                <p>
                  We provide cutting-edge solutions, prioritize your vision, test
                  applications carefully and support you from conception to launch
                  and beyond.
                </p>
              </div>
            </Col>

            <Col lg={7}>
              <div className="website-app-reason-list">
                {appReasons.map((item) => (
                  <div key={item.title}>
                    <span>✓</span>
                    <div>
                      <h3>{item.title}</h3>
                      <p>{item.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="website-final-section">
        <Container>
          <div className="website-final-card">
            <div className="website-section-label">Let's Build Your App Together</div>
            <h2>Let’s craft something remarkable</h2>
            <p>
              EBS Software Solution is here to make your app dreams come true,
              whether you're a startup with a game-changing idea or an
              established company looking to expand your digital footprint.
              Together, let's craft something remarkable.
            </p>
          </div>
        </Container>
      </section>

      <section className="website-corporate-keywords-section">
        <Container>
          <div className="website-corporate-keywords-head">
            <div className="website-section-label">Related Solutions</div>
            <h2>Website development, Android app, iOS app and digital solution search terms</h2>
            <p>
              EBS Software Solution covers important website and app development
              requirements with professional web design, custom web application,
              e-commerce, CMS, Android app, iOS app, UI/UX and maintenance
              services.
            </p>
          </div>

          <Row className="g-4">
            {relatedSearchGroups.map((group) => (
              <Col lg={6} key={group.title}>
                <div className="website-corporate-keyword-card">
                  <h3>{group.title}</h3>
                  <p>{group.text}</p>

                  <div className="website-corporate-keyword-list">
                    {group.terms.map((term) => (
                      <span key={term}>{term}</span>
                    ))}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </main>
  );
};

export default Website;